import {api} from '../../../shared';
import {PrepareUploadResponse, UserModel} from '../model';

export interface UploadResponse {
  fileId: string;
}

export const usersApi = {
  getUser: async () => {
    const {data} = await api.get<UserModel>(`/api/iam/public/users/me`);
    return data;
  },
  getUsersByIds: async (ids: string[]): Promise<UserModel[]> => {
    const {data} = await api.get<UserModel[]>('/api/iam/public/users', {
      params: {ids},
      paramsSerializer: {
        indexes: null,
      },
    });
    return data;
  },
  lockUser: async (userId: string) => {
    const {data} = await api.post<void>(`/api/iam/admin/users/${userId}/lock`);
    return data;
  },
  unlockUser: async (userId: string) => {
    const {data} = await api.delete<void>(`/api/iam/admin/users/${userId}/lock`);
    return data;
  },
  prepareUploadAvatar: async (contentTypes: string[]) => {
    const {data} = await api.post<PrepareUploadResponse>('/api/files/public/prepare-upload', {
      contentTypes,
    });
    return data;
  },

  uploadFile: async (userId: string, payload: Record<string, any>) => {
    const {data} = await api.post<UploadResponse>(`/api/iam/admin/users/${userId}/avatar`, payload);
    return data;
  },

  deleteAvatar: async (userId: string) => {
    const {data} = await api.delete<void>(`/api/iam/admin/users/${userId}/avatar`);
    return data;
  },
};
